export default "__VITE_ASSET__DQIdKQrc__"